/* src/app/builder-screen-beta/components/data-grid/data-grid.component.scss */
.data-grid-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.data-grid-container > [hidden] {
  display: none !important;
}
.data-grid-container .flip-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background:
    linear-gradient(
      135deg,
      #f6f8fc 0%,
      #eef1f7 100%);
  border: 1px solid #d9e0ea;
  border-radius: 6px;
  margin-bottom: 4px;
}
.data-grid-container .toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  gap: 16px;
}
.data-grid-container .toolbar .toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.data-grid-container .toolbar .toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.data-grid-container .table-wrapper {
  width: 100%;
  overflow: visible;
  position: relative;
}
.data-grid-container .table-wrapper ::ng-deep .ant-table-body::-webkit-scrollbar,
.data-grid-container .table-wrapper ::ng-deep .ant-table-content::-webkit-scrollbar {
  height: 10px !important;
}
.data-grid-container .table-wrapper ::ng-deep .ant-table-body::-webkit-scrollbar-track,
.data-grid-container .table-wrapper ::ng-deep .ant-table-content::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}
.data-grid-container .table-wrapper ::ng-deep .ant-table-body::-webkit-scrollbar-thumb,
.data-grid-container .table-wrapper ::ng-deep .ant-table-content::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 4px;
}
.data-grid-container .table-wrapper ::ng-deep .ant-table-body::-webkit-scrollbar-thumb:hover,
.data-grid-container .table-wrapper ::ng-deep .ant-table-content::-webkit-scrollbar-thumb:hover {
  background: #999;
}
.data-grid-container .data-grid-table {
  width: 100%;
  min-width: 100%;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table {
  font-size: 13px;
  table-layout: auto;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table thead > tr > th {
  background-color: #fafafa;
  font-weight: 600;
  padding: 12px 8px;
  white-space: nowrap;
  min-width: 100px;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table thead > tr > th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  transition: background-color 0.2s;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table thead > tr > th.sortable:hover {
  background-color: #f0f0f0;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table thead > tr > th .column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table thead > tr > th .column-header .sort-icon {
  font-size: 12px;
  color: #1890ff;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr:hover {
  background-color: #f5f5f5;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr.selected {
  background-color: #e6f7ff !important;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td {
  padding: 10px 8px;
  white-space: nowrap;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.number-cell {
  justify-content: flex-end;
  font-family: "Courier New", monospace;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.date-cell {
  font-size: 12px;
  color: #666;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.boolean-cell {
  justify-content: center;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable {
  position: relative;
  min-width: 120px;
  background-color: #fafafa;
  border-radius: 4px;
  padding: 2px;
  cursor: text;
  transition: all 0.2s;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable:hover {
  background-color: #e6f7ff;
  box-shadow: 0 0 0 1px #91d5ff;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable .cell-input {
  width: 100%;
  font-size: 13px;
  border: 1px solid transparent;
  transition: all 0.2s;
  padding: 4px 8px;
  border-radius: 2px;
  background-color: transparent;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable .cell-input:hover {
  border-color: #40a9ff;
  background-color: #fff;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable .cell-input:focus {
  border-color: #40a9ff;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  outline: none;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable ::ng-deep nz-input-number {
  width: 100%;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable ::ng-deep nz-input-number .ant-input-number {
  width: 100%;
  border-color: transparent;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable ::ng-deep nz-input-number .ant-input-number:hover {
  border-color: #d9d9d9;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable ::ng-deep nz-input-number .ant-input-number:focus,
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable ::ng-deep nz-input-number .ant-input-number-focused {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .cell-content.editable ::ng-deep nz-switch .ant-switch {
  margin: 0;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .action-buttons button {
  padding: 0 4px;
  height: 24px;
}
.data-grid-container .data-grid-table ::ng-deep .ant-table tbody > tr td .action-buttons button i {
  font-size: 14px;
}
.data-grid-container .data-grid-table ::ng-deep .ant-empty {
  margin: 40px 0;
}
.data-grid-container .pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-top: 1px solid #f0f0f0;
}
.data-grid-container .pagination-container .pagination-info {
  font-size: 13px;
  color: #666;
}
.data-grid-container .pagination-container .pagination-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}
.data-grid-container .pagination-container .pagination-buttons .page-number {
  min-width: 32px;
}
.data-grid-container .crud-actions {
  margin-top: 8px;
}
.data-grid-container .crud-actions button {
  height: 40px;
  font-size: 14px;
}
.data-grid-container .crud-actions button i {
  font-size: 16px;
}
.spreadsheet-cell {
  cursor: cell;
  padding: 0 !important;
  min-height: 32px;
}
.spreadsheet-cell:hover:not(.spreadsheet-active) {
  background-color: #f0f7ff;
}
.spreadsheet-cell.spreadsheet-active {
  background-color: #e6f4ff;
  box-shadow: inset 0 0 0 2px #1890ff;
  padding: 0 !important;
}
.spreadsheet-readonly {
  padding: 6px 8px;
  min-height: 32px;
  display: flex;
  align-items: center;
}
.spreadsheet-cell-input {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  width: 100%;
  height: 100%;
  padding: 4px 8px !important;
}
.spreadsheet-cell-input:focus {
  border: none !important;
  box-shadow: none !important;
}
@media (max-width: 768px) {
  .data-grid-container .toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .data-grid-container .toolbar .toolbar-left,
  .data-grid-container .toolbar .toolbar-right {
    justify-content: center;
  }
  .data-grid-container .pagination-container {
    flex-direction: column;
    gap: 12px;
  }
  .data-grid-container .pagination-container .pagination-info {
    order: 2;
  }
  .data-grid-container .pagination-container .pagination-buttons {
    order: 1;
    flex-wrap: wrap;
    justify-content: center;
  }
}
/*# sourceMappingURL=data-grid.component.css.map */
